"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _formUrlencodedClient = _interopRequireDefault(require("./formUrlencodedClient"));

var ROOT_URL = 'email/v1/bcc';

var BccEmailAPI =
/*#__PURE__*/
function () {
  function BccEmailAPI() {
    (0, _classCallCheck2.default)(this, BccEmailAPI);
  }

  (0, _createClass2.default)(BccEmailAPI, null, [{
    key: "disableBccEmail",
    value: function disableBccEmail() {
      return _apiClient.default.post(ROOT_URL + "/disable", {
        data: {}
      });
    }
  }, {
    key: "resendBccEmailConfirmation",
    value: function resendBccEmailConfirmation() {
      return _apiClient.default.post(ROOT_URL + "/resendConfirmation", {
        data: {}
      });
    }
  }, {
    key: "sendBccEmailConfirmation",
    value: function sendBccEmailConfirmation(_ref) {
      var bccEmail = _ref.bccEmail;
      return _formUrlencodedClient.default.post(ROOT_URL + "/sendConfirmation", {
        data: {
          bccEmail: bccEmail
        }
      });
    }
  }]);
  return BccEmailAPI;
}();

exports.default = BccEmailAPI;
module.exports = exports.default;